import { render } from "./DesktopSwitch.vue?vue&type=template&id=9d4c5caa&scoped=true"
import script from "./DesktopSwitch.vue?vue&type=script&lang=js"
export * from "./DesktopSwitch.vue?vue&type=script&lang=js"

import "./DesktopSwitch.vue?vue&type=style&index=0&id=9d4c5caa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d4c5caa"]])

export default __exports__